// extracted by mini-css-extract-plugin
export var card = "benefitCard-module--card--11uKM";
export var icon = "benefitCard-module--icon--20qAb";